import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { CheckCircle, Warning, Clock } from "@phosphor-icons/react";

import { PUBLIC_BACKEND as BACKEND } from "@/lib/api";

export default function DriverVerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState({ loading: true, ok: false, message: "" });

  useEffect(() => {
    if (!token) {
      setState({ loading: false, ok: false, message: "Missing verification token." });
      return;
    }
    axios
      .get(`${BACKEND}/api/public/drivers/verify-email`, { params: { token } })
      .then((r) => setState({ loading: false, ok: true, message: r.data.message || "Email verified." }))
      .catch((err) => setState({ loading: false, ok: false, message: err.response?.data?.detail || "Verification failed." }));
  }, [token]);

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6" data-testid="driver-verify-email-page">
      <div className="max-w-md w-full bg-white border border-zinc-200 rounded-xl p-8 text-center shadow-sm">
        {state.loading ? (
          <>
            <Clock size={26} weight="bold" className="text-zinc-400 mx-auto mb-3 animate-pulse" />
            <p className="text-sm text-zinc-500">Verifying…</p>
          </>
        ) : state.ok ? (
          <>
            <div className="w-14 h-14 rounded-full bg-emerald-500/10 border border-emerald-500/30 mx-auto flex items-center justify-center mb-5">
              <CheckCircle size={26} weight="bold" className="text-emerald-600" />
            </div>
            <h1 className="text-2xl font-semibold tracking-tight mb-2" style={{ fontFamily: "Work Sans" }}>Email verified!</h1>
            <p className="text-zinc-600 mb-5" data-testid="driver-verify-message">{state.message}</p>
            <Link to="/"><Button className="w-full bg-[#002BF6] hover:bg-[#0021C7] text-white">Back to Kanal</Button></Link>
          </>
        ) : (
          <>
            <div className="w-14 h-14 rounded-full bg-red-50 border border-red-200 mx-auto flex items-center justify-center mb-4">
              <Warning size={26} weight="bold" className="text-red-600" />
            </div>
            <h1 className="text-2xl font-semibold tracking-tight mb-2" style={{ fontFamily: "Work Sans" }}>Verification failed</h1>
            <p className="text-zinc-600 mb-5">{state.message}</p>
            <Link to="/driver/signup"><Button variant="outline" className="w-full">Apply again</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
